module.exports = __webpack_public_path__ + "files/40b8f874c14913f0635d52dd5672ff6a.png";